<template>
  <!-- 案件詳細 -->
  <div id="HSTRequestDetail">
    <div  id="item-contens" style="text-align:right;">
        <b-button v-if="requestCancel" class="is-primary" style="margin-right:3%;" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
    </div>
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">基本情報</span>
        <table v-if="data.delivaryTarget=='home'">
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>        
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.isResultMailSend"></b-checkbox>解析結果のダウンロードURLを医療機関にメールで通知する。</td></tr>
            <tr v-if="data.isResultMailSend"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
          <tr><th>機種</th><td>{{data.model | getNameFilter(models)}}</td></tr>
          <template v-if="isWP300(data.model)">
            <tr><th>いびきセンサー同梱の有無</th><td>{{setSnoreSensorValue(data.snoreSensor)}}</td></tr>
          </template>
          <tr><th>配送先</th><td>患者宅に配送する</td></tr>
          <template v-if="data.resultReceiverName">
            <tr><th>【結果送付先】</th></tr>
            <tr><th>郵便番号</th><td>{{data.resultZip}}</td></tr>
            <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.resultAddress}}</td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td>{{data.resultBuildingName}}</td></tr>
            <tr><th>医療機関名(会社名)</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.resultCompanyName}}</td></tr>
            <tr><th>診療科(部署名)</th><td>{{data.resultDivision}}</td></tr>
            <tr><th>宛名</th><td>{{data.resultReceiverName}}</td></tr>
            <tr><th>連絡先(電話番号)</th><td>{{data.resultPhoneNumber}}</td></tr>
          </template>
          <tr>
            <th>ePatch同梱の有無</th>
            <td v-if="data.holterRequestId">有</td>
            <td v-else>無</td>
          </tr>
          <tr><th>納品書</th><td><span v-if="data.deliverySlip">必要</span><span v-else>不要</span></td>
          <tr><th>デモ</th><td :class="{ 'strong text-red': data.demo && $route.params.callSearchFlag }"><b-checkbox style="width:26px;" value="true" disabled v-model="data.demo"/>デモ(トライアル)</td></tr>
        </table>
        <table v-else>
          <tr><th>医療機関名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospitalName}}</td></tr>
          <tr><th>医師名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.doctorName}}</td></tr>
          <tr><th>事務担当者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.clerkName}}</td></tr>
          <template v-if="data.isDealer">
            <tr><th>医療機関メールアドレス</th><td><b-checkbox style="width: 26px" value="true" disabled v-model="data.isResultMailSend"></b-checkbox>解析結果のダウンロードURLを医療機関にメールで通知する。</td></tr>
            <tr v-if="data.isResultMailSend"><th></th><td>{{data.hospitalMail}}</td></tr>
          </template>
          <tr><th>機種</th><td>{{data.model | getNameFilter(models)}}</td></tr>
          <template v-if="isWP300(data.model)">
            <tr><th>いびきセンサー同梱の有無</th><td>{{setSnoreSensorValue(data.snoreSensor)}}</td></tr>
          </template>
          <tr><th>配送先</th><td>医療機関に配送する</td></tr>
          <tr><th>郵便番号</th><td>{{data.zip}}</td></tr>
          <tr><th>住所（都道府県、市町村区）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address}}</td></tr>
          <tr><th>住所（それ以降の住所）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address1}}</td></tr>
          <tr><th>住所（建物名、部屋番号）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.address2}}</td></tr>
          <tr><th>宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receiverName}}</td></tr>
          <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
          <tr><th>配達希望時間帯</th><td>{{data.desiredDeliveryTimeZone | getNameFilter(timeZone)}}</td></tr>
          <template v-if="data.resultReceiverName">
            <tr><th>【結果送付先】</th></tr>
            <tr><th>郵便番号</th><td>{{data.resultZip}}</td></tr>
            <tr><th>住所</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.resultAddress}}</td></tr>
            <tr><th>住所（建物名、部屋番号）</th><td>{{data.resultBuildingName}}</td></tr>
            <tr><th>医療機関名(会社名)</th><td>{{data.resultCompanyName}}</td></tr>
            <tr><th>診療科(部署名)</th><td>{{data.resultDivision}}</td></tr>
            <tr><th>宛名</th><td>{{data.resultReceiverName}}</td></tr>
            <tr><th>連絡先(電話番号)</th><td>{{data.resultPhoneNumber}}</td></tr>
          </template>
          <tr>
            <th>ePatch同梱の有無</th>
            <td v-if="data.holterRequestId">有</td>
            <td v-else>無</td>
          </tr>
          <tr><th>納品書</th><td><span v-if="data.deliverySlip">必要</span><span v-else>不要</span></td>
          <tr><th>デモ</th><td :class="{ 'strong': data.demo && $route.params.callSearchFlag }"><b-checkbox style="width:26px;" value="true" disabled v-model="data.demo"/>デモ(トライアル)</td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-for="(patient, index) in data.patientsData" :key="index">
        <span v-if="data.patientsData.length>1" style="font-size:20px;">患者情報{{index+1}}</span>
        <span v-else style="font-size:20px;">患者情報</span>
        <table  v-if="data.delivaryTarget=='home'" class="">
          <tr><th>診察券ID（患者ID）</th><td>{{patient.patientId}}</td></tr>
          <tr><th>患者名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyName+" "+patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.patientFamilyNameKana+" "+patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td>{{patient.gender}}</td></tr>
          <tr><th>生年月日</th><td>{{patient.birthday | formatDate()}}<span v-if="patient.birthday" style="margin-left:10px;">{{patient.japaneseCalendar}}</span></td></tr>
          <tr><th>年齢</th><td>{{patient.age}}</td></tr>
          <tr v-if="isSW()"><th>カニューラサイズ</th><td>{{patient.cannulaSize | getNameFilter(cannulaSize)}}</td></tr>
          <tr v-if="isSW()"><th>ベルトサイズ</th><td>{{patient.beltSize | getNameFilter(beltSize)}}</td></tr>
          <tr v-if="isSW()"><th>添付波形</th><td>{{patient.attachedWaveform | getNameFilter(attachedWaveform)}}</td></tr>
          <tr><th>次回受診日</th><td>{{patient.nextDate | formatDate()}}</td></tr>
          <tr><th>郵便番号</th><td>{{patient.zip}}</td></tr>
          <tr><th>住所（都道府県、市町村区）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address}}</td></tr>
          <tr><th>住所（それ以降の住所）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address1}}</td></tr>
          <tr><th>住所（建物名、部屋番号）</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{patient.address2}}</td></tr>
          <tr><th>宛名</th><td>{{patient.receiverName}}</td></tr>
          <tr><th>連絡先（自宅または携帯）</th><td>{{patient.phoneNumber}}</td></tr>
          <tr><th>配達希望時間帯</th><td>{{patient.desiredDeliveryTimeZone | getNameFilter(timeZone)}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{patient.memo}}</div></td></tr>
        </table>
        <table  v-else>
          <tr><th>診察券ID（患者ID）</th><td>{{patient.patientId}}</td></tr>
          <tr><th>患者名</th><td>{{patient.patientFamilyName+" "+patient.patientFirstName}}</td></tr>
          <tr><th>患者名（カナ）</th><td>{{patient.patientFamilyNameKana+" "+patient.patientFirstNameKana}}</td></tr>
          <tr><th>性別</th><td>{{patient.gender}}</td></tr>
          <tr><th>生年月日</th><td>{{patient.birthday | formatDate()}}</td></tr>
          <tr><th>年齢</th><td>{{patient.age}}</td></tr>
          <tr v-if="isSW()"><th>カニューラサイズ</th><td>{{patient.cannulaSize | getNameFilter(cannulaSize)}}</td></tr>
          <tr v-if="isSW()"><th>ベルトサイズ</th><td>{{patient.beltSize | getNameFilter(beltSize)}}</td></tr>
          <tr v-if="isSW()"><th>添付波形</th><td>{{patient.attachedWaveform | getNameFilter(attachedWaveform)}}</td></tr>
          <tr><th>次回受診日</th><td>{{patient.nextDate | formatDate()}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{patient.memo}}</div></td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">配送情報</span>
        <table>
          <tr><th>出荷日</th><td>{{data.shippingDate | formatDate()}}</td></tr>
          <tr><th>返却日</th><td>{{data.returnDate | formatDate()}}</td></tr>
          <tr v-if="data.invoiceNumber || data.paymentNumber"><th>送り状番号</th><td>{{data.invoiceNumber}}</td></tr>
          <tr v-if="data.invoiceNumber || data.paymentNumber"><th>着払い番号</th><td>{{data.paymentNumber}}</td></tr>
          <tr><th style="vertical-align:top;">備考、その他、注意事項</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.memo}}</div></td></tr>
        </table>
      </div>
      <ReExaminationDetailPart :detailData="data"/>
      <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
        <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
      </b-modal>
      <CancelDetailPart :detailData="data"/>
    </div>
  </div>
</template>

<script>
import {choicesType, hstModelValue} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import ReExaminationDetailPart from "./components/ReExaminationDetailPart.vue"
import CancelDetailPart from "./components/CancelDetailPart.vue"

export default {
  name: "HSTRequestDetail",
  props: ["data","requestCancel"],
  methods: {
    isSW: function() {
      var model = this.models.find(val => val.value == this.data.model)
      if(model && model.label1.match(/スマートウォッチ/)){
        return true
      }
      return false
    },
    isWP300: function(modelId) {
      if(modelId == hstModelValue.WP300){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = !snoreSensor || snoreSensor === "1" ? "無" : "有";
      return setSnoreSensorValue;
    },
    cancel: function(cancelReason) {
      this.$emit('cancel', "HST", cancelReason);
      this.$parent.close();
    }
  },
  data() {
    let models = this.getChoiceList(choicesType.hstKind, true);
    let timeZone = this.getChoiceList(choicesType.deliveryTime, true);
    let cannulaSize = this.getChoiceList(choicesType.cannulaSize, true);
    let beltSize = this.getChoiceList(choicesType.beltSize, true);
    let attachedWaveform =  this.getChoiceList(choicesType.attachedWaveform, true);
    for(var i=0; i<this.data.patientsData.length; i++){
      if(this.data.patientsData[i].birthday){
        const date = new Date(this.data.patientsData[i].birthday);
        const options = {era: 'long'};
        this.data.patientsData[i]["japaneseCalendar"]  = "【"+this.getJapaneseCalendar(date)+"】"
      }
    }
    return {
      models: models,
      timeZone: timeZone,
      cannulaSize: cannulaSize,
      beltSize: beltSize,
      attachedWaveform: attachedWaveform,
      cancelReasonInputModalActive:false
    };
  },
  filters: {
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    ReExaminationDetailPart,
    CancelDetailPart,
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.strong {
  font-size: 18px !important;
  font-weight: bold;
  color : red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/HSTRequestDetail.vue